import React, { FC } from 'react';

import s from './PostHeader.module.scss';


export const PostHeader: FC = ({ children }) => {
  return (
    <h1 className={s.postHeader}>{children}</h1>
  );
};
